// Add your custom JS here.
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { CSSRulePlugin } from "gsap/dist/CSSRulePlugin";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CSSRulePlugin);

jQuery(document).ready(function ($) {
    $('#main-menu > li:not(.btn) > a').on('click', function (e) {
        e.preventDefault();
        $(this).parent('li').siblings('li').find('.mega-submenu').removeClass('open');
        $(this).parent('li').find('.mega-submenu').toggleClass('open');
        $(this).parent('li').siblings('li').removeClass('active');
        $('.search-wrap').removeClass('active');
    })
    $('#main-menu > li.menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();
        $(this).parent('li').toggleClass('active');
    })
    $('.search-icon').on('click', function (e) {
        $('.search-wrap').toggleClass('active');
        $('.mega-submenu').removeClass('open');
        $('li.menu-item-has-children').removeClass('active');
        $('.navbar-collapse').removeClass('show');
    })
    $('.navbar-toggler').on('click', function (e) {
        $('.search-wrap').removeClass('active');
    })
    $('.featured-programs-slider').slick({
        infinite: true,
        slidesToShow: 1,
    });
    $('.wp-block-gb-for-slick-slider-slick-slider').slick('slickSetOption', 'infinite', true, true);
    $('.featured-news-slider').slick({
        infinite: true,
        slidesToShow: 1,
    });
    $('.sidebar a.top-level').on('click touchstart', function (e) {
        e.preventDefault();
        $(this).siblings('ul.sub-menu').slideToggle();
    })
    window.addEventListener('click', function (e) {
        if (!document.getElementById('navbarNavDropdown').contains(e.target)) {
            const submenus = document.querySelectorAll('.mega-submenu');
            submenus.forEach((submenu) => {
                submenu.parentNode.classList.remove("active");
                submenu.classList.remove('open');
            });
        }
    })

    //animations
    //headings mostly, but things slide in from the left.
    const slideIn = document.querySelectorAll('.animate-slide-in');

    if (slideIn.length) {
        ScrollTrigger.batch(slideIn, {
            start: 'top 80%',
        //   end: 'bottom 90%',
            once: true,
            markers: false,
            onEnter: batch => gsap.fromTo(batch,
            { autoAlpha: 0, x: -50 },
            { autoAlpha: 1, x: 0, opacity: 1, duration: 0.66 }
            )
        })
    }

    //slide program page stuff up
    const slideUp = document.querySelectorAll('.animate-slide-up');

    if (slideUp.length) {
        ScrollTrigger.batch(slideUp, {
            start: 'top 80%',
        //   end: 'bottom 90%',
            once: true,
            markers: false,
            onEnter: batch => gsap.fromTo(batch,
            { y: 120, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.75 }
            )
        })
    }

    //items fade in sequentially, no horizontal or vertical movement
    const fadeStagger = document.querySelectorAll('.animate-fade-stagger');
    
    if (fadeStagger.length) {
        fadeStagger.forEach((el) => {
            const fadeStaggers = el.children;
            gsap.from(fadeStaggers, {
            scrollTrigger: {
                trigger: fadeStaggers[0],
                start: 'top 80%',
                // end: 'bottom 90%',
                once: true,
                markers: false,
            },
            autoAlpha: 0,
            duration: 1.5,
            ease: 'sine',
            stagger: 0.25
            });
        });
    };

    // animation for thin callout
    const iconGrow = document.querySelectorAll('.animate-icon-grow');
    
    if (iconGrow.length) {
        ScrollTrigger.batch(iconGrow, {
            start: 'top 70%',
        //   end: 'bottom 90%',
            once: true,
            yoyo: true,
            duration: 1.2,
            onEnter: batch => gsap.to(batch, {
                keyframes: {
                    "0%":   { scale: 1},
                    "50%":  { scale: 1.25},
                    "100%": { scale: 1 },
                    easeEach: 'easeInOut'
                },
            }
            )
        })
    };

    //headings mostly, but things slide in from the left.
    const scrollIn = document.querySelectorAll('.animate-scroll-in');
    let mm = gsap.matchMedia();

    // add a media query. When it matches, the associated function will run
    mm.add("(min-width: 577px)", () => {

        if (scrollIn.length) {
            ScrollTrigger.batch(scrollIn, {
                start: 'top 70%',
            //   end: 'bottom 90%',
                once: true,
                markers: false,
                onEnter: batch => gsap.to(batch,
                { x: 1016, duration: 1.2 }
                )
            })
        }
    });
    const popupCardModal = document.querySelectorAll('.popup-modal');

    MicroModal.init({
        openTrigger: 'data-custom-open',
        // closeTrigger: 'data-custom-close',
        disableScroll: true,
        disableFocus: popupCardModal.length > 0 ? true : false,
        // awaitOpenAnimation: true,
        // awaitCloseAnimation: false,
        debugMode: true
    });
});